import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { devices } from 'styles/devices';

const Image = ({ src, alt, className }) => (
   <ImageBlock className={className}>
      <Img src={src} alt={alt} />
   </ImageBlock>
);

const ImageBlock = styled.div`
   margin: 20px auto;

   ${devices.mobileL} {
      margin: 0 auto;
   }
`;

const Img = styled.img`
   display: block;
   width: 100%;
`;

Image.propTypes = {
   className: PropTypes.string,
   src: PropTypes.string.isRequired,
   alt: PropTypes.string
};

Image.defaultProps = {
   className: '',
   alt: ''
};

export default Image;
